import { createSlice } from "@reduxjs/toolkit";

export interface StoreSearch {
  params: SearchParams;
}

export interface SearchParams {
  [key: string]: string;
  boro: string;
  houseNo: string;
  streetName: string;
  aptNo: string;
}

export const initSearch: StoreSearch = {
  params: {
    boro: "",
    houseNo: "",
    streetName: "",
    aptNo: "",
  },
};

export const searchSlice = createSlice({
  name: "search",
  initialState: initSearch,
  reducers: {
    resetSearch: (state) => {
      state.params = initSearch.params;
    },
    updateSearch: (state, action: { payload: SearchParams }) => {
      state.params = action.payload;
    },
    updateSearchField: (
      state,
      action: { payload: { field: string; value: string } },
    ) => {
      state.params[action.payload.field] = action.payload.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { resetSearch, updateSearchField, updateSearch } =
  searchSlice.actions;

export default searchSlice.reducer;
